import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Link,
  Route
} from "react-router-dom";
import QuoteComponent from "./Component/QuoteComponent";
import LoginComponent from "./Component/LoginComponent";
import RegisterComponent from "./Component/RegisterComponent";
import PublicComponent from "./Component/PublicComponent";
import PSpaceComponent from "./Component/PSpaceComponent";
import AuthService from './service/AuthService' ;
import './App.css';



class App extends React.Component {

  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);
    this.getCurrentUser = this.getCurrentUser.bind(this);

    this.state = {
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined
    };
  }
  componentDidMount() {
    this.getCurrentUser();
  }

  logOut() {
    AuthService.logout();
    this.setState({
      currentUser: undefined
    });

  }
getCurrentUser() {
  const user = AuthService.getCurrentUser();

  if (user) {
    this.setState({
      currentUser: user,
      showBossBoard: user.roles.includes("ROLE_BOSS"),
      showAdminBoard: user.roles.includes("ROLE_ADMIN")
    });
  }

}

render(){
  return (
<Router>
<div>
  <nav class="navbar navbar-expand-md navbar-light bg-light shadow ">
    <div class="container"> 
    <Link class="navbar-brand text-primary" to="/" >
        <i className="fa d-inline fa-umbrella fa-lg text-danger"></i>
        <b className="text-dark" > Mondevis-ma</b>
    </Link> 
        <button class="navbar-toggler navbar-toggler-right border-0" type="button" data-toggle="collapse" data-target="#navbar4">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbar4">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item"> <Link class="nav-link" to="/Auto" ><i class="fa fa-fw fa-car"></i>Auto / Moto</Link> </li>
          <li class="nav-item"> <Link class="nav-link disabled" to="/Mrh"><i class="fa fa-fw fa-home"></i>Habitation</Link> </li>
          <li class="nav-item"> <Link class="nav-link disabled" to="/Plais"><i class="fa fa-fw fa-ship"></i>Plaisance</Link> </li>
          {this.state.currentUser ? (
            <li class="nav-item dropdown">
               <a class="nav-link dropdown-toggle" href="{#}" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
               <i class="fa fa-fw fa-home"></i>Bienvenue {this.state.currentUser.username}
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <Link class="dropdown-item" to="/profile" ><i class="fa fa-fw fa-user"></i>Mon espace</Link>
                <Link class="dropdown-item" to="/" onClick={this.logOut}><i class="fa fa-fw fa-sign-out"></i>Logout</Link>
                </div>
                </li>
              ) : 
                <li class="nav-item"> <Link class="nav-link" to="/login"><i class="fa fa-fw fa-sign-in"></i>Mon espace</Link> </li>
              }
        </ul> 
        <Link class="btn navbar-btn ml-md-2 btn-success text-white"  to="/register"><i class="fa fa-fw fa-user-plus"></i>S'inscrire</Link>
      </div>
    </div>
  </nav>
  <Switch>
    <Route path="/Auto" component={QuoteComponent} />
    <Route exact path={["/login"]} render={(props) => <LoginComponent {...props} getCurrentUser={this.getCurrentUser} />} />
    <Route path="/register" component={RegisterComponent} />
    <Route path="/profile" component={PSpaceComponent} />
    <Route path="/" render={(props) => <PublicComponent {...props} />}  />
    
  </Switch>
  <div class="bg-light">
    <div class="container">
      <div class="row">
        <div class="p-4 col-md-3">
          <h4 class="mb-4">A propos</h4>
          <p>Mondevis-ma est un POC permettant de calculer rapidement la prime d'un devis assurance</p>
        </div>
        <div class="p-4 col-md-3">
          <h4 class="mb-4">Mapsite</h4>
          <ul class="list-unstyled"> <a href="/Auto" class="text-dark">Auto / Moto</a> <br/> <a href="{#}" class="text-dark">Habitation</a> <br/> <a href="{#}" class="text-dark">Plaisance</a> <br/> <a href="{#}" class="text-dark">Equipe</a> </ul>
        </div>
        <div class="p-4 col-md-3">
          <h4 class="mb-4">Contact</h4>
          <p> <a href="{#}" class="text-dark">
              <i class="fa d-inline mr-3 text-muted fa-phone"></i>+212- XXX YYY OOOO</a></p>
          <p> <a href="{#}" class="text-dark">
              <i class="fa d-inline mr-3 text-muted fa-envelope"></i>f.tabouti@gmail.com</a></p>
          <p> <a href="{#}" class="text-dark">
              <i class="fa d-inline mr-3 fa-map-marker text-muted"></i>Casablanca, Maroc</a></p>
        </div>
        <div class="p-4 col-md-3">
          <h4 class="mb-4">Abonnez-vous</h4>
          <form>
            <fieldset class="form-group"> <label for="exampleInputEmail1">Recevez notre newsletter</label> <input type="email" class="form-control" placeholder="Entrer votre émail"/> </fieldset> <button type="submit" class="btn btn-secondary">Envoyer</button>
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mt-3">
          <p class="text-center">© Copyright 2020 Mondevis-ma - Tous droits réservés</p>
        </div>
      </div>
    </div>
  </div>
</div>
</Router>
      );
    }
  };

export default App;
